export default __webpack_public_path__ + "static/media/rug10-min.951565eb.jpg";